@if (title) {
  <h4 mat-dialog-title>{{title}}</h4>
}
<mat-dialog-content>
  <form #blockUserForm="ngForm" autocomplete="off">
    @if (!displayMessageAsHTML) {
      <p>
        {{message}}
      </p>
    }
    @if (displayMessageAsHTML) {
      <div [innerHTML]="message"></div>
    }
    <h5 class="mt-3 font-medium">Block Reason</h5>
    <div class="flex flex-col">
      <mat-form-field>
        <mat-select matInput name="blockReason" [(ngModel)]="selectedBlockReason" required>
          @for (blockReason of blockReasons; track blockReason) {
            <mat-option [value]="blockReason">
              {{blockReason}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="w-full" [ngStyle]="{'display': (selectedBlockReason=='Other') ? 'block' : 'none'}">
        <mat-label>Block Reason</mat-label>
        <input matInput [(ngModel)]="otherBlockReason" name="otherBlockReason" maxlength="200"
          [required]="selectedBlockReason=='Other'">
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="dialog-footer-buttons">{{cancelButtonText}}</button>
    <button mat-raised-button [color]="okButtonColor" [disabled]="!blockUserForm.valid" class="dialog-footer-buttons"
    (click)="onOkClick()">{{okButtonText}}</button>
  </mat-dialog-actions>
  
